// All global styling for Phlex pages should be included in this file.
import '@consumer/styles/global.scss'
import '@consumer/styles/giftly_image.scss'
import '@consumer/components/GButton.vue'
import '@consumer/components/GIcon.vue'
import '@consumer/modules/v2/layout/Footer.vue'

// Page specific styles should be imported after components and before utilities.
import '@consumer/styles/consumer_gift_cards.scss'

// Utility styles should be imported after more specific styles.
import 'windi.css'

// Note: We don't init sentry here, because there is no Vue app, if we want
// frontend sentry support, we'll need to do it the normal rails frontend way
export { initTracking } from '@shared/tracking'
export { setupHowItWorks } from '@consumer/global'
export { registerInlineEditorComponent } from '@consumer/components/PhlexLandingPageInlineEditor'

import GFlashManager from '@consumer/modules/shared/GFlashManager.vue'
createApp(GFlashManager).mount('#flash-manager')

import ModalsManager from '@consumer/modules/shared/ModalsManager.vue'
createApp(ModalsManager).mount('#modals-manager')

import { checkAddUsernamePrompt } from '@consumer/composables/useAddUsernamePrompt'
checkAddUsernamePrompt()

function markHydrated () {
  document.documentElement.dataset.appHydrated = 'true'
}

if (document.readyState === 'loading')
  document.addEventListener('DOMContentLoaded', markHydrated, { once: true })
else
  markHydrated()
